import React from 'react';
import CommonIcon from '../helpers/icons';
import { CreateAccountapi, verifyEmail,ResendOtp } from '../../action/createaccountapi';
import withRouter from "../custom/withRouter";
import { connect } from "react-redux";
import Spinner from 'react-bootstrap/Spinner';

class CreateAccountContinue extends React.Component {
   constructor(){
      super()
      this.state={
        otp: ['', '', '', '', '', ''],
        opterror:'',
        invalidOTP:'',
        spinner:false,
        disabled: false,
        countdown: 60 ,
        sentences: [
          'Tenant creation is currently in progress. Please don\`t close the tab',
          '',
          'We are processing your data, Please wait ',
          '',
          
          
        ],
        currentSentenceIndex: 0,
        fadeIn: true 
      }
      this.timer = null;
      this.inputRefs = [
        React.createRef(),
        React.createRef(),
        React.createRef(),
        React.createRef(),
        React.createRef(),
        React.createRef()
      ];
   }
   componentDidMount() {
    this.interval = setInterval(this.changeSentence, 4000); // Change sentence every 3 seconds (adjust as needed)
  }
   componentWillUnmount() {
    clearInterval(this.timer); // Clean up timer on component unmount
    clearInterval(this.interval);
  }
  
  changeSentence = () => {
    const { sentences, currentSentenceIndex } = this.state;
    const nextIndex = (currentSentenceIndex + 1) % sentences.length; // Loop through sentences

    this.setState({
      currentSentenceIndex: nextIndex,
      fadeIn: !this.state.fadeIn // Toggle fade in/out class
    });
  };

  handleResendOTP = () => {
    this.setState({ disabled: true });

    this.timer = setInterval(() => {
      this.setState((prevState) => ({
        countdown: prevState.countdown - 1
      }));

      if (this.state.countdown === 0) {
        clearInterval(this.timer);
        this.setState({ disabled: false, countdown: 60 }); // Reset countdown after 1 minute
      }
    }, 1000); // Update countdown every second
  };
 

   handleChange = (index, e) => {
    const { value } = e.target;
    const otpCopy = [...this.state.otp];

    otpCopy[index] = value;

    this.setState({
      otp: otpCopy,
      
    }, () => {
      // Move focus to the next input field
      if (value && index < this.inputRefs.length - 1) {
        this.inputRefs[index + 1].current.focus();
      }
    });
  };

  handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && index > 0 && !this.state.otp[index]) {
      // Move focus to the previous input field on Backspace
      this.inputRefs[index - 1].current.focus();
    }
  };
  
  handlePaste = (event) => {
    event.preventDefault();
    const pasteData = event.clipboardData.getData('text');
    const newOtp = pasteData.split('').slice(0, this.state.otp.length);

    this.setState({ otp: newOtp });

    // Move focus to the last input field after pasting
    if (newOtp.length > 0) {
      this.inputRefs[newOtp.length - 1].current.focus();
    }
  };

  verify = () =>{
    
   console.log(this.state.otp);
   let otpvalues=this.state.otp.join('');
   if(otpvalues.length==6){
    console.log(otpvalues);
    
    let usermail=localStorage.getItem('userNameTAC');
    let data={
        "email" : usermail,
	      "otp": otpvalues
    }
    this.state.opterror='';
    this.props.dispatch(verifyEmail(data));
   
    // })
    // this.state.invalidOTP=localStorage.getItem('invalidotp')?localStorage.getItem('invalidotp'):'';
   }
   else
   {
    this.state.opterror='Please check your OTP has 6 digits';
    this.state.invalidOTP='';
   }
   
   let local=localStorage.getItem('invalidotpTAC')?localStorage.getItem('invalidotpTAC'):'';
   console.log(local);
   // this.setState({
     this.state.invalidOTP=localStorage.getItem('invalidotpTAC')?localStorage.getItem('invalidotpTAC'):''
   localStorage.removeItem('invalidotpTAC');
  console.log( this.props.verifyEmail);
   
  }

  resend = () =>{
    // let usermail=localStorage.getItem('Usermail')
    this.props.dispatch(ResendOtp())
    this.handleResendOTP()
  }
  loginRedirect =() =>{
    // localStorage.setItem('AccessToken',rawToken);
    // localStorage.setItem('Role',decodedToken.user_role);
    // localStorage.setItem('isLogin',true);
    // localStorage.setItem('realmName',decodedToken.tenant_id)
    console.log('HELLO');
    let role=localStorage.getItem('RoleTAC');
    if(role=="Admin"){
      window.location.href = '/users';
    }
  }
   
  render(){
    const { disabled, countdown, sentences, currentSentenceIndex, fadeIn  } = this.state;

    // console.log(this.state.otp);
    
    return(
        <div className='main'>
            <div className='h-100'> 
                <div className='tpcontent'> 
                    <div className='pl-3'>         
                        <CommonIcon fileName={'Flazlogo'}/> 
                    </div>
                    
                </div>

                <div className='email-main'>   
                
                <div className='email-card'>
                   <div>
                    <div className='mail-icon w-100' style={{display:this.props.verifyEmail?.status=="Success"?'none':'block'}}>
                          <CommonIcon fileName={'emailIcon'} />
                      </div>
                        
                      <div className='mail-icon w-100' style={{display:this.props.verifyEmail?.status=="Success"?'block':'none'}}>
                          <CommonIcon fileName={'successTick'}/>
                      </div>
                   </div>
                    
                    <div className='text-center'>
                        <label className='verifylabel' style={{display:this.props.verifyEmail?.status=="Success"?'none':'block'}}> We just emailed you</label>
                        <p className='verify-para' style={{display:this.props.verifyEmail?.status=="Success"?'none':'block'}}>Please enter the code we sent </p>
                    </div> 
                    <div style={{display:this.props.verifyEmail?.status=="Success"?'none':'block'}}>

                    {this.state.otp.map((digit, index) => (
                            <input
                                key={index}
                                type="tel"
                                maxLength={1}
                                value={digit}
                                ref={this.inputRefs[index]}
                                onChange={(e) => this.handleChange(index, e)}
                                onKeyDown={(e) => this.handleKeyDown(index, e)}
                                className="otp-input"
                                disabled={this.props.isRegisterLoad}
                                onPaste={this.handlePaste}
                                
                            />
                            ))}
                            
                    </div>
                    <span className='isrequired' style={{fontSize:'14px'}}>{this.state.opterror!=""?this.state.opterror:''}</span>
                    <span className='isrequired' style={{fontSize:'14px'}}>{this.props.verifyEmail?.status=="Fail"?this.props.verifyEmail?.message:''}</span>
                    <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
                        <button type='submit' className='verify-btn rounded' id='verify' style={{display:this.props.verifyEmail?.status=="Success"?'none':'block'}} onClick={this.verify}>Verify</button>
                        {/* <label className={`spinnermsg ${fadeIn ? 'fade-in' : 'fade-out'}`} style={{display:this.props.isRegisterLoad?'block':'none',marginTop:'30px'}}>{sentences[currentSentenceIndex]}</label>
                        <Spinner animation="border" variant="primary" style={{display:this.props.isRegisterLoad?'block':'none',marginTop:'10px'}}/> */}
                        {/* <button className='verify-btn' style={{display:this.props.RegisterKeycloak?'block':'none',marginTop:'30px'}} onClick={this.loginRedirect} type='submit'>LOGIN</button> */}
                        <div className='w-75 text-center'>
                        <label className='spinnermsg' style={{fontSize:'17px'}}>{this.props.verifyEmail?.status=="Success"?this.props.verifyEmail?.message:''}</label>
                        </div>
                        
                    </div>
                    
                    <div className='resend'>
                        <p className='resend-para'  style={{display:this.props.verifyEmail?.status=="Success"?'none':'block'}}>Didn't get the code? {disabled?`Wait for ${countdown} to resend OTP`:<span className='isblue' onClick={this.resend}>Resend</span>} </p> 
                    </div>
                </div>
                </div>
            </div>
        </div>
    )
  }
}

function mapDispatchToProps(dispatch) {
    return { dispatch };
  }
  
  function mapStateToProps(state) {
    return {
    
         CreateAccountapi:state.createAccountReducer.CreateAccountapi,
         verifyEmail:state.createAccountReducer.verifyEmail,
         ResendOtp:state.createAccountReducer.ResendOtp,
         RegisterKeycloak:state.createAccountReducer.RegisterKeycloak,
         isLoading: state.commonReducer.isLoading,
         isRegisterLoad: state.commonReducer.isRegisterLoad,

    };
  }
  export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CreateAccountContinue)
  );